import { useState } from 'react';
import { DRAG_OPACITY_DEFAULT, DRAG_OPACITY_DURING_DRAG } from '@entities/leadCollector/model/consts';

interface UseDragAndDropProps {
  onReorder?: (dragIndex: number, dropIndex: number) => void;
}

interface UseDragAndDropReturn {
  draggedIndex: number | undefined;
  draggedOverIndex: number | undefined;
  handleDragStart: (e: React.DragEvent, index: number) => void;
  handleDragEnd: (e: React.DragEvent) => void;
  handleDragOver: (e: React.DragEvent, index: number) => void;
  handleDrop: (e: React.DragEvent, dropIndex: number) => void;
}

export const useDragAndDrop = ({ onReorder }: UseDragAndDropProps = {}): UseDragAndDropReturn => {
  const [draggedIndex, setDraggedIndex] = useState<number | undefined>(undefined);
  const [draggedOverIndex, setDraggedOverIndex] = useState<number | undefined>(undefined);

  const handleDragStart = (e: React.DragEvent, index: number) => {
    const target = e.target as HTMLElement;
    const isBubbleMenu = target.querySelector('div[tabindex="0"][style*="visibility: visible"]');

    if (isBubbleMenu) {
      e.preventDefault();
      return;
    }

    setDraggedIndex(index);
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = String(DRAG_OPACITY_DURING_DRAG);
    }
  };

  const handleDragEnd = (e: React.DragEvent) => {
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = String(DRAG_OPACITY_DEFAULT);
    }
    setDraggedIndex(undefined);
    setDraggedOverIndex(undefined);
  };

  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();

    if (draggedIndex === undefined || draggedIndex === index) {
      setDraggedOverIndex(undefined);
      return;
    }

    setDraggedOverIndex(index);
  };

  const handleDrop = (e: React.DragEvent, dropIndex: number) => {
    e.preventDefault();

    if (draggedIndex !== undefined && draggedIndex !== dropIndex && onReorder) {
      onReorder(draggedIndex, dropIndex);
    }

    setDraggedIndex(undefined);
    setDraggedOverIndex(undefined);
  };

  return {
    draggedIndex,
    draggedOverIndex,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDrop,
  };
};
